import { useBiTrack } from '../../../composables/use-bi-track';
import { useEditionControl } from './use-edition-control';
import { BiTrackPoint, AIR_UPGRADE_EVENT_TYPE } from '../constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { usePackageInfo } from './use-package-info';
import { computed } from 'vue';
import _ from 'lodash';

export function useEditionTag(props: { isLogin: boolean }) {
  const { biTrack } = useBiTrack(AIR_UPGRADE_EVENT_TYPE);

  const { isFreemium } = useEditionControl();
  const { packageInfo, hasTrialPackage } = usePackageInfo();

  enum PopoverType {
    SINGLE = 'SINGLE',
    MULTI = 'MULTI',
    SINGLE_AIR_TRIAL = 'SINGLE_AIR_TRIAL',
  }

  const currentEditionPopoverType = computed(() => {
    if (isFreemium.value) {
      return PopoverType.SINGLE;
    }

    if (!hasTrialPackage.value) {
      return false;
    }

    if (packageInfo.value.length > 1) {
      return PopoverType.MULTI;
    }

    if (_.find(packageInfo.value, { eureka_package: EurekaPackageType.AIR_TRIAL })) {
      return PopoverType.SINGLE_AIR_TRIAL;
    }

    return PopoverType.MULTI;
  });

  const singleAirTrialLeftDays = computed(() => {
    const airTrialPackage = _.find(packageInfo.value, {
      eureka_package: EurekaPackageType.AIR_TRIAL,
    });
    return airTrialPackage ? airTrialPackage.trial_package_left_days : 0;
  });

  const transformLeftDays = (leftDays: number) => {
    if (leftDays <= 1) {
      return `<span style="font-weight: 600;color: red;">${leftDays || '-'}</span>`;
    }

    return `<span>${leftDays || '-'}</span>`;
  };

  const isEditionVisible = computed(() => {
    return currentEditionPopoverType.value && props.isLogin;
  });

  const trialPackages = computed(() => {
    return _.filter(packageInfo.value, (pkg) => {
      return _.has(pkg, 'trial_package_left_days');
    });
  });

  function handleUpgrade() {
    biTrack({
      sourceType: BiTrackPoint.AIR_HEADER_UPGRADE_CLICK,
    });
    location.href = '/user-setting/package';
  }

  return {
    currentEditionPopoverType,
    singleAirTrialLeftDays,
    transformLeftDays,
    isEditionVisible,
    trialPackages,
    handleUpgrade,
    hasTrialPackage,
    PopoverType,
  };
}
